import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon, CheckIcon } from "lucide-react";
type MediaSplitProps = {
  id: string;
  eyebrow: string;
  title: string;
  text: string;
  points: string[];
  image: string;
  imageAlt: string;
  note?: string;
  cta?: {
    label: string;
    to: string;
  };
  reverse?: boolean;
  background?: "white" | "soft";
};
export function MediaSplit({
  id,
  eyebrow,
  title,
  text,
  points,
  image,
  imageAlt,
  note,
  cta,
  reverse = false,
  background = "white"
}: MediaSplitProps) {
  const ctaClass = "mt-8 inline-flex items-center gap-2 text-sm font-bold text-rinnai transition-colors duration-150 ease-out hover:text-rinnaiDark";
  return <section className={`${background === "soft" ? "bg-soft" : "bg-white"} py-8 lg:py-14`} aria-labelledby={id} data-id="element-188" data-mp="3pkqt6slugdef">
      <div className="mx-auto grid max-w-[1320px] items-center gap-10 px-5 lg:grid-cols-2 lg:gap-16 lg:px-10" data-id="element-189" data-mp="zvy8isxc6hcp">
        <div className={`overflow-hidden rounded-lg bg-stone ${reverse ? "lg:order-2" : ""}`} data-id="element-190" data-mp="14tq9sdjvfftk">
          <img src={image} alt={imageAlt} className="aspect-[4/3] h-full w-full object-cover" data-id="element-191" data-mp="1gxbqqvaceo29" />
        </div>
        <div data-id="element-192" data-mp="1bz0gwkk1sdk1">
          <p className="text-sm font-bold text-rinnai" data-id="element-193" data-mp="1bza6w853ekpq">{eyebrow}</p>
          <h2 id={id} className="mt-4 text-3xl font-bold tracking-[-0.04em] sm:text-4xl" data-id="element-194" data-mp="16ycp3wnzvsor">{title}</h2>
          <p className="mt-5 text-lg leading-8 text-muted" data-id="element-195" data-mp="120azstzz6x4u">{text}</p>
          <ul className="mt-7 grid gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-196" data-mp="1225macqwaxb1">
            {points.map(point => <li key={point} className="flex gap-2 text-sm font-semibold leading-6 text-ink" data-id="element-197" data-mp="t7hfuj9l39kn">
                <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-rinnai" aria-hidden="true" data-id="element-198" data-mp="o8e9mvhvaxb3" />
                {point}
              </li>)}
          </ul>
          {cta && (cta.to.startsWith("#") ? <a href={cta.to} className={ctaClass} data-id="element-199" data-mp="e9yrvj4qd0e9">{cta.label} <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-200" data-mp="e9p2nxriex9m" /></a> : <Link to={cta.to} className={ctaClass} data-id="element-201" data-mp="a9wnh27m1sva">{cta.label} <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-202" data-mp="3vsw01tm55d32" /></Link>)}
          {note && <p className="mt-5 text-xs leading-5 text-muted" data-id="element-203" data-mp="4ml3a9o5yyhj">{note}</p>}
        </div>
      </div>
    </section>;
}